export enum ProposalType {
  BUY = "BUY",
  PROVIDER = "PROVIDER"
}

export enum ProposalStatus {
  DRAFT = "DRAFT",
  CANCELLED = "CANCELLED",
  SENT = "SENT",
  ACCEPTED = "ACCEPTED",
  PENDING_MODIF = "PENDING_MODIF",
  COMPLETED = "COMPLETED"
};

export interface ProposalActionItem {
  action: ProposalAction,
  title: string,
  icon?: string
};

export interface BuyActionItem {
  action: BuyAction,
  title: string,
  icon?: string
};

export enum ProposalAction {
  CREATE = "CREATE",
  CANCEL = "CANCEL",
  CANCEL_MODIF = "CANCEL_MODIF",
  EDIT = "EDIT",
  EDIT_MODIF = "EDIT_MODIF",
  SEND = "SEND",
  REOPEN = "REOPEN",
  ACCEPT = "ACCEPT",
  ACCEPT_MODIF = "ACCEPT_MODIF",
  COMPLETE = "COMPLETE"
}

export enum BuyAction {
  CREATE = "CREATE",
  EDIT = "EDIT",
  PUBLISH = "PUBLISH",
  CLOSE = "CLOSE",
  SHARE = "SHARE",
  TOGGLE_FAV = "TOGGLE_FAV"
}


export class BuyBasicData{

  public static proposalActionItems : ProposalActionItem[] = [
      {
        action: ProposalAction.CREATE,
        title: "Créer",
        icon: 'add'
      },
      {
        action: ProposalAction.ACCEPT,
        title: "Accepter",
        icon: 'accept'
      },
       {
        action: ProposalAction.ACCEPT_MODIF,
        title: "Accepter Modif",
        icon: 'accept'
      },
      {
        action: ProposalAction.CANCEL,
        title: "Annuler",
        icon: 'cancel'
      },
      {
        action: ProposalAction.CANCEL_MODIF,
        title: "Annuler Modif",
        icon: 'cancel'
      },
      {
        action: ProposalAction.COMPLETE,
        title: "Compléter",
        icon: 'complete'
      },
      {
        action: ProposalAction.EDIT,
        title: "Editer",
        icon: 'edit'
      },
      {
        action: ProposalAction.EDIT_MODIF,
        title: "Editer modif",
        icon: 'edit'
      },
      {
        action: ProposalAction.REOPEN,
        title: "Réouvrir",
        icon: 'open'
      },
      {
        action: ProposalAction.SEND,
        title: "Envoyer",
        icon: 'send'
      }
  ];

  
  public static buyActionItems : BuyActionItem[] = [
      {
        action: BuyAction.CREATE,
        title: "Créer",
        icon: 'add'
      },
      {
        action: BuyAction.TOGGLE_FAV,
        title: "Favori",
        icon: 'favorite'
      },
      {
        action: BuyAction.CLOSE,
        title: "Fermer",
        icon: 'close'
      },
      {
        action: BuyAction.EDIT,
        title: "Editer",
        icon: 'edit'
      },
      {
        action: BuyAction.PUBLISH,
        title: "Publier",
        icon: 'post'
      },
      {
        action: BuyAction.SHARE,
        title: "Partager",
        icon: 'share'
      }
  ];

}

